export default __webpack_public_path__ + "static/media/offer-icon-private.45cc3d5f.svg";